export default "__VITE_ASSET__4vnzZqvV__"